var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_30034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.95431 0 0 8.9543 0 20C0 31.0457 8.95431 40 20 40Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5311 15.6523H22.5106L20.0004 11.3044L17.4904 15.6523H12.4697L14.9802 20.0001L12.4697 24.3479H17.4904L20.0004 28.6957L22.5106 24.3479H27.5311L25.0207 20.0001L27.5311 15.6523ZM23.0844 20.0001L21.5425 22.671H18.4586L16.9164 20.0001L18.4585 17.3291H21.5425L23.0844 20.0001ZM20.0004 14.6581L20.5743 15.6522H19.4267L20.0004 14.6581ZM15.3743 17.3291H16.5221L15.9482 18.3232L15.3743 17.3291ZM15.3743 22.671L15.9483 21.6769L16.5222 22.671H15.3743ZM20.0004 25.3419L19.4266 24.3479H20.5743L20.0004 25.3419ZM24.6265 22.671H23.4787L24.0527 21.6769L24.6265 22.671ZM23.4787 17.3291H24.6265L24.0526 18.3232L23.4787 17.3291Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4498 4.3479H7.55031C5.72508 5.80165 4.15977 7.56743 2.93555 9.56532H37.0646C35.8403 7.56751 34.275 5.80165 32.4498 4.3479Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.55031 35.6522H32.4498C34.275 34.1985 35.8403 32.4327 37.0645 30.4348H2.93555C4.15984 32.4326 5.72516 34.1985 7.55031 35.6522Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_30034"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHe);
export default __webpack_public_path__ + "static/media/he.46c8e2a84fa6653a2c30ba75d2725375.svg";
export { ForwardRef as ReactComponent };